import { render } from "./PaggueFormDialog.vue?vue&type=template&id=48538d53&scoped=true"
import script from "./PaggueFormDialog.vue?vue&type=script&lang=js"
export * from "./PaggueFormDialog.vue?vue&type=script&lang=js"

import "./PaggueFormDialog.vue?vue&type=style&index=0&id=48538d53&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48538d53"]])

export default __exports__